
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IConteudo } from '@/models/Entidades/IConteudo';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import EditorHtml from '@/core/components/UI/EditorHtml.vue';
import Seo from '@/components/Seo.vue';
import ServicoPagina from '@/servicos/ServicoPagina';
import { IResposta } from '@/core/models/IResposta';
import { IEstrutura } from '@/models/Entidades/IEstrutura';
import { ETipoEstrutura } from '@/models/Enumeradores/ETipoEstrutura';
import { ETipoConteudo } from '@/models/Enumeradores/ETipoConteudo';

export default defineComponent({
  name: 'PaginaCadastro',
  components: {
    ComunicacaoApi,
    EditorHtml,
    Seo,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoPagina = new ServicoPagina();

    const state = reactive({
      pagina: {} as IConteudo,
    });

    async function obterConteudo(codigo:number) {
      appBase.carregando = true;
      state.pagina = await servicoPagina.obter(codigo);
      appBase.carregando = false;
    }

    function limparDados() {
      state.pagina = {} as IConteudo;
      state.pagina.codigo = 0;
      state.pagina.tipo = ETipoConteudo.Pagina;
      state.pagina.status = true;
      state.pagina.estrutura = {} as IEstrutura;
      state.pagina.estrutura.codigo = 0;
      state.pagina.estrutura.indexar = true;
      state.pagina.estrutura.tipo = ETipoEstrutura.Pagina;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigoConteudo = obterCodigoRota();
      if (codigoConteudo > 0) {
        await obterConteudo(codigoConteudo);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da página.');
      if (state.pagina.codigo === 0) {
        state.pagina.estrutura.url = 'url';
        appBase.resposta = await servicoPagina.incluir(state.pagina);
      } else {
        appBase.resposta = await servicoPagina.atualizar(state.pagina);
      }

      apresentarRespostaRedirecionamento('Paginas');
    }
    return {
      appBase,
      state,
      salvar,
    };
  },
});
